module.exports = __webpack_public_path__ + "assets/img/mhtml.82e034fa.svg";